import styled from 'vue-styled-components'
const DashLineWrapperProps = {
  custom_style: {
    paddingTop: Number,
    paddingBottom: Number,
    paddingLeft: Number,
    paddingRight: Number,
  },
}
const DashLineWrapper = styled('div', DashLineWrapperProps)`
& > div {
  position: absolute;
  pointer-events: auto;
  background-color: #ffffffb3;

  &.left, &.right {
    cursor: col-resize;
    top: 0;
    height: 100%;
    width: 1px;
    border-left: 1px dashed #808080e0;
    .label{
      top: 50%;
    }
    &::before {
      content: ' ';
      display: block;
      height: 100%;
      width: 7px;
      position: absolute;
      left: -4px;
      top: 0;
    }
    &:active {
      &::after{
        display: block;
      }
    }
    &::after{
      content: '';
      height: 100%;
      background-color:#12a9ff59;
      display: none;
      position: absolute;
    }
  }
  &.left {
    left: ${({ custom_style }) => custom_style.paddingLeft}px;
   
    &::after {
      width: ${({ custom_style }) => custom_style.paddingLeft}px;
      right: 0;
    }
  }
  &.right {
    right:  ${({ custom_style }) => custom_style.paddingRight}px;
    .label{
      right: 100%;
    }
    &::after {
      width: ${({ custom_style }) => custom_style.paddingRight}px;
    }
  }
  &.top,  &.bottom {
    cursor: row-resize;
    left: 0;
    height: 1px;
    width: 100%;
    border-top: 1px dashed #808080e0;
    .label{
      left: 50%;
    }
    &::before {
      position: absolute;
      content: ' ';
      display: block;
      width: 100%;
      height: 7px;
      top: -4px;
      left: 0;
    }
    &:active {
      &::after{
        display: block;
      }
    }
    &::after{
      content: '';
      width: 100%;
      background-color:#12a9ff59;
      display: none;
      position: absolute;
    }
  }
  &.top  {
    top: ${({ custom_style }) => custom_style.paddingTop}px;
 
    &::after {
      height: ${({ custom_style }) => custom_style.paddingTop}px;
      bottom: 0;
    }
  }
  &.bottom {
    .label{
      bottom: 50%;
    }
    bottom: ${({ custom_style }) => custom_style.paddingBottom}px;
    &::after {
      height: ${({ custom_style }) => custom_style.paddingBottom}px;
    }
  }
}
`
const ToolLabel = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  height: 25px;
  width: fit-content;

  padding: 0px 8px;
  border-radius: 4px;
`

export {
  DashLineWrapper,
  ToolLabel
}